// Custom Pagination Component for "Homes for Sale" Section Only
// Always shows both previous and next buttons with disabled states

import React from "react";
import PropTypes from "prop-types";
import { Pagination, Icon } from "semantic-ui-react";
import { Title } from "../../components";

const HomeSalePagination = ({ length, prev, active, perpage, ...props }) => {
  let id = { ...props };
  let perpages = perpage ? perpage : 1; // Default to 1 for homes section
  let pages = Math.ceil(length / perpages);
  let prevCond = active <= 1;
  let nextCond = active >= pages;

  return (
    <div
      style={{
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "70px",
        marginTop: "20px",
      }}
      className="home_sale_pagination"
    >
      {/* Previous Button - Always visible, disabled on first page */}
      <Pagination
        boundaryRange={0}
        secondary
        activePage={active}
        ellipsisItem={null}
        firstItem={null}
        lastItem={null}
        totalPages={pages}
        prevItem={{
          content: (
            <Title size="small" color={prevCond ? "grey" : "blue"}>
              <Icon name="angle left" />
            </Title>
          ),
          icon: true,
          disabled: prevCond,
          className: prevCond ? "disabled-pagination-btn" : "",
        }}
        nextItem={null}
        pageItem={null}
        onPageChange={(e, value) => {
          if (!prevCond) {
            prev(e, { value }, id);
          }
        }}
      />

      {/* Next Button - Always visible, disabled on last page */}
      <Pagination
        boundaryRange={0}
        secondary
        activePage={active}
        ellipsisItem={null}
        firstItem={null}
        lastItem={null}
        totalPages={pages}
        prevItem={null}
        nextItem={{
          content: (
            <Title size="small" color={nextCond ? "grey" : "blue"}>
              <Icon name="angle right" />
            </Title>
          ),
          icon: true,
          disabled: nextCond,
          className: nextCond ? "disabled-pagination-btn" : "",
        }}
        pageItem={null}
        onPageChange={(e, value) => {
          if (!nextCond) {
            prev(e, { value }, id);
          }
        }}
      />
    </div>
  );
};

HomeSalePagination.propTypes = {
  length: PropTypes.number.isRequired,
  prev: PropTypes.func.isRequired,
  active: PropTypes.number.isRequired,
  perpage: PropTypes.number,
};

export default HomeSalePagination;
